import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import logoImage from '../../assets/images/LifeCoachAssist-logo-03.png';

const { FiCheckCircle, FiMail, FiAlertCircle } = FiIcons;

const RegistrationSuccessPage = ({ email }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center p-4 mt-4 pt-safe">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md"
      >
        <div className="bg-white rounded-2xl shadow-2xl p-8 text-center">
          {/* Logo */}
          <div className="mb-6 flex justify-center">
            <img src={logoImage} alt="Life Coach Assist" className="h-16 w-auto" />
          </div>

          {/* Success Icon */}
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, type: 'spring', stiffness: 100 }}
            className="mb-6"
          >
            <div className="flex justify-center">
              <div className="relative">
                <div className="absolute inset-0 bg-green-100 rounded-full animate-pulse"></div>
                <SafeIcon
                  icon={FiCheckCircle}
                  className="text-green-600 relative"
                  size={64}
                />
              </div>
            </div>
          </motion.div>

          {/* Heading */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              Registration Complete!
            </h1>
            <p className="text-gray-600 mb-6">
              Thank you for registering with Life Coach Assist.
            </p>
          </motion.div>

          {/* Main Message Box */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="bg-green-50 border-2 border-green-200 rounded-xl p-6 mb-6"
          >
            <div className="flex items-start mb-4">
              <SafeIcon
                icon={FiMail}
                className="text-green-600 mt-1 mr-3 flex-shrink-0"
              />
              <div className="text-left flex-1">
                <h2 className="text-lg font-semibold text-green-900 mb-2">
                  Check Your Email
                </h2>
                <p className="text-green-800 mb-3">
                  We've sent a confirmation email to:
                </p>
                <p className="text-sm font-mono bg-white border border-green-200 rounded p-2 text-green-900 mb-3 break-all">
                  {email}
                </p>
                <p className="text-green-800 mb-2">
                  <strong>Click the confirmation link</strong> in the email to activate your account.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Secondary Message - Check Spam */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            className="bg-amber-50 border border-amber-200 rounded-lg p-4"
          >
            <div className="flex items-start">
              <SafeIcon
                icon={FiAlertCircle}
                className="text-amber-600 mt-0.5 mr-3 flex-shrink-0"
              />
              <div className="text-left">
                <h3 className="text-sm font-semibold text-amber-900 mb-1">
                  Don't see the email?
                </h3>
                <p className="text-sm text-amber-800">
                  Please also check your <strong>spam or junk folder</strong>. Sometimes our emails end up there by mistake.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Info Text */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
            className="text-gray-600 text-sm mt-6"
          >
            Once you confirm your email, you'll be able to sign in and start using Life Coach Assist.
          </motion.p>
        </div>
      </motion.div>
    </div>
  );
};

export default RegistrationSuccessPage;
